import { useQuery } from '@tanstack/react-query';
import { getCommissionComments } from 'config/requests/commissions';

export const useCommissionComments = (id: number | undefined, enabled = true) => {
  const { data: comments = [], isLoading } = useQuery({
    queryKey: ['commissions/comments', id],
    queryFn: () => getCommissionComments(id!),
    enabled: Boolean(id) && enabled,
  });

  return { comments, isLoading };
};
